/**
 * Bookings + Stripe Connect callable wrappers (Phase 7).
 *
 * Frontend mirror of `functions/bookingsFn.js`. All callables are
 * region-pinned to us-central1 via the shared functions instance.
 */

import { httpsCallable } from "firebase/functions";
import { functions } from "../FirebaseConfig";
import { apiLogger } from "../services/LoggingService";

function call(name) {
  const fn = httpsCallable(functions, name);
  return async (input) => {
    try {
      const res = await fn(input);
      return res.data;
    } catch (err) {
      apiLogger.error(`callable ${name} failed`, err, { input });
      throw err;
    }
  };
}

const _createConnectAccount         = call("createConnectAccount");
const _createConnectAccountLink     = call("createConnectAccountLink");
const _getConnectAccountStatus      = call("getConnectAccountStatus");
const _createBookingCheckoutSession = call("createBookingCheckoutSession");
const _confirmBooking               = call("confirmBooking");
const _cancelBooking                = call("cancelBooking");
const _refundBooking                = call("refundBooking");
const _listMyBookings               = call("listMyBookings");
const _listBusinessBookings         = call("listBusinessBookings");
const _setDefaultCommissionPct      = call("setDefaultCommissionPct");
const _getBookingsConfig            = call("getBookingsConfig");
const _setListingCommissionOverride = call("setListingCommissionOverride");
const _getBookingsHealth            = call("getBookingsHealth");

export const createConnectAccount     = () => _createConnectAccount({});
export const createConnectAccountLink = () => _createConnectAccountLink({});
export const getConnectAccountStatus  = () => _getConnectAccountStatus({});

export const createBookingCheckoutSession = ({
  listingId = null,
  eventId = null,
  amountCents,
  quantity = 1,
  bookingDate = null,
  note = "",
}) => _createBookingCheckoutSession({ listingId, eventId, amountCents, quantity, bookingDate, note });

export const confirmBooking = (bookingId) => _confirmBooking({ bookingId });
export const cancelBooking = (bookingId, reason = "") => _cancelBooking({ bookingId, reason });
export const refundBooking = (bookingId, reason = "") => _refundBooking({ bookingId, reason });

export const listMyBookings = (limit = 50) => _listMyBookings({ limit });
export const listBusinessBookings = ({ businessId, statusFilter = null, limit = 50 }) =>
  _listBusinessBookings({ businessId, statusFilter, limit });

export const setDefaultCommissionPct = (pct) => _setDefaultCommissionPct({ pct });
export const getBookingsConfig = () => _getBookingsConfig({});
export const setListingCommissionOverride = (listingId, pct) =>
  _setListingCommissionOverride({ listingId, pct });

export const getBookingsHealth = () => _getBookingsHealth({});
